import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useMutation } from "shared/hooks/useApi";
import graphql from "utils/api/graphql";
import { INITIAL_VALUES, SCREENS } from "utils/constants";
import View from "./View";

const Delete = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [visible, setVisible] = useState(true);
  const cancel = () => navigate(SCREENS.PRIVATE.BROKER.TASKS.LIST.path);
  const [deleteTask] = useMutation(graphql.mutations.DELETE_TASK, {
    refetchQueries: [
      {
        query: graphql.queries.TASKS,
        awaitRefetchQueries: true,
        variables: INITIAL_VALUES,
      },
    ],
    onCompleted: (_) => {
      setVisible(false);
      navigate(SCREENS.PRIVATE.BROKER.TASKS.LIST.path);
    },
    onError: () => {},
  });
  const onSubmit = () => {
    return deleteTask({
      variables: {
        where: {
          id,
        },
      },
    });
  };

  return <View onSubmit={onSubmit} cancel={cancel} visible={visible} />;
};

export default Delete;
